import { defaultStore } from './defaultStore';
import { defineStore } from "pinia";

export default defineStore('calculations_types', defaultStore('calculations/calculations_types/',));
